/**
 * Render a buyer's stored UTC offset, which the backend keeps in MINUTES
 * (Google's `utc_offset_minutes`, passed through unchanged).
 *
 * Minutes are shown alongside the readable offset on purpose: a value like `2`
 * is a legal offset of two minutes, so an hours-vs-minutes mistake upstream is
 * only visible if the raw number is visible too.
 */
export const formatUtcOffset = (offsetMinutes: number): string => {
  const sign = offsetMinutes < 0 ? '-' : '+';
  const absolute = Math.abs(offsetMinutes);
  const hours = Math.floor(absolute / 60);
  const minutes = absolute % 60;
  const padded = (value: number) => String(value).padStart(2, '0');

  return `UTC${sign}${padded(hours)}:${padded(minutes)} (${offsetMinutes} min)`;
};
